module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"step-one-subtitle":"1.验证手机号","step-two-subtitle":"2.重置密码","new-password":"新密码","confirm-password":"确认密码","password-placeholder":"8-20个字符，同时包含数字和字母","confirm-password-placeholder":"请再次输入密码","count-one":"当前账号 手机号 ","count-two":"，请重置密码","document-title":"重置密码"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
